<div class="login-page font-normal">
    <div class="login-container">
      <div class="header  flex items-center">
        <div class="img-cntr">
          <img src="./images/logo.png" width="100" height="100" alt="NCMS" />
        </div>
        <div class="m-auto">
          <h1>NIGERIA CASE MANAGEMENT SYSTEM</h1>
        </div>
      </div>
      <div class="content-center">
        <div class="login-info">
          <form class="flex flex-col" [formGroup]="resetForm" (ngSubmit)="onSubmit()">
            <h2 class="text-xl mb-4">Forgot Password</h2>
      
            <mat-form-field class="w-full" appearance="outline">
              <mat-icon matPrefix>person</mat-icon>
              <input matInput type="text" formControlName="userName" placeholder="Username" />
              <mat-error class="!text-white">Field value required</mat-error>
            </mat-form-field>
              <mat-form-field class="rounded-md">
                <mat-icon matPrefix fontIcon="mail" class="border-r border-solid text-slate-400"></mat-icon>
                <input type="text" formControlName="email" matInput placeholder="E-Mail" />
                <mat-error class="!text-white">Field value required</mat-error>
              </mat-form-field>
      
            <div class="flex flex-wrap gap-3 justify-center mt-4">
              <button type="submit" mat-flat-button class="btn-sign">Submit</button>
              <button type="reset" mat-flat-button class="btn-sign" (click)="onReset()">Cancel</button>
            </div>
          </form>
        </div>
      </div>
      
      </div>
     
    </div>
  
  